import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import icon from '@fortawesome/fontawesome-free-solid/faChevronRight';

class Search extends React.Component {
  render() {
    return (
	  <FontAwesomeIcon icon={icon} />
    )
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/UI/Button/Arrow.js